var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotegWebsiteLogo2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2379.667,
    height: 825.64,
    viewBox: "0 0 2379.667 825.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.044,
    y1: 0.5,
    x2: 1,
    y2: 0.46,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9d3cae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fc9e4d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-new",
    transform: "translate(-2017.333 -1381.18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(366 -0.014)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Technologies",
    transform: "translate(2666 1950)",
    fill: "#272727",
    fontSize: 139,
    fontFamily: "TwCenMT-Regular, Tw Cen MT",
    letterSpacing: "0.292em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "TECHNOLOGIES")), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M5556.673,2615.524a33.934,33.934,0,1,1-33.932-33.937,33.93,33.93,0,0,1,33.932,33.937m548.119,0a33.937,33.937,0,1,0,33.936-33.937A33.931,33.931,0,0,0,6104.792,2615.524Zm-548.119-194.314a33.934,33.934,0,1,0-33.932,33.934A33.931,33.931,0,0,0,5556.673,2421.209Zm176.9-176.9a33.937,33.937,0,1,1,33.937-33.937A33.929,33.929,0,0,1,5733.575,2244.308Zm194.315,0a33.937,33.937,0,1,0-33.935-33.937A33.932,33.932,0,0,0,5927.89,2244.308Zm-94.574-89.922a24.421,24.421,0,1,0-24.422-24.419A24.421,24.421,0,0,0,5833.316,2154.386Zm363.977,363.98a24.422,24.422,0,1,0,24.422-24.422A24.422,24.422,0,0,0,6197.293,2518.366Zm-463.718,274.06a33.934,33.934,0,1,0,33.937,33.932A33.927,33.927,0,0,0,5733.575,2792.426Zm194.315,0a33.934,33.934,0,1,1-33.935,33.932A33.93,33.93,0,0,1,5927.89,2792.426Zm-94.574,89.917a24.421,24.421,0,1,1-24.422,24.423A24.422,24.422,0,0,1,5833.316,2882.343Zm-363.978-363.976a24.421,24.421,0,1,1-24.42-24.422A24.421,24.421,0,0,1,5469.339,2518.366Zm361.393-138.175a56.371,56.371,0,1,1,56.371-56.371A56.368,56.368,0,0,1,5830.731,2380.191Zm138.176,138.175a56.371,56.371,0,1,1,56.372,56.37A56.371,56.371,0,0,1,5968.908,2518.366Zm56.372,265.717a71.174,71.174,0,0,1-71.176-71.17c0-64.3-59.072-123.372-123.372-123.372s-123.367,59.073-123.367,123.372a71.175,71.175,0,1,1-71.175-71.175c64.3,0,123.37-59.077,123.37-123.372S5700.489,2395,5636.189,2395a71.173,71.173,0,1,1,71.175-71.176c0,64.3,59.071,123.372,123.367,123.372S5954.1,2388.12,5954.1,2323.82A71.175,71.175,0,1,1,6025.279,2395c-64.3,0-123.372,59.072-123.372,123.37s59.076,123.372,123.372,123.372a71.173,71.173,0,1,1,0,142.345Zm-194.548-127.541a56.368,56.368,0,1,0,56.371,56.37A56.365,56.365,0,0,0,5830.731,2656.543Zm-138.171-138.177a56.371,56.371,0,1,0-56.371,56.37A56.371,56.371,0,0,0,5692.561,2518.366Zm412.231-97.157a33.937,33.937,0,1,1,33.936,33.934A33.931,33.931,0,0,1,6104.792,2421.209Z",
    transform: "translate(-3769.163 -724.351)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Innovation._Trust._Value",
    "data-name": "Innovation. Trust. Value",
    transform: "translate(2782 2097)",
    fill: "#f46e41",
    fontSize: 116,
    fontFamily: "TwCenMT-Regular, Tw Cen MT",
    letterSpacing: "0.045em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Innovation. Trust. Value"))), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M1363.849,1452.482v.133c-11.856.291-21.72,2.075-29.378,5.521a49.083,49.083,0,0,0-19.814,15.435,56.921,56.921,0,0,0-10.011,22.521,130.783,130.783,0,0,0-2.708,27.326v99.429a130.8,130.8,0,0,0,2.708,27.327,57.052,57.052,0,0,0,10.011,22.533,49.288,49.288,0,0,0,19.814,15.435c7.658,3.434,17.521,5.218,29.378,5.51l99.333.108a20.907,20.907,0,0,0,20.931-20.907h0a20.906,20.906,0,0,0-20.908-20.9H1376.36c-10.461-.206-17.316-3.059-20.4-8.688-3.2-5.837-4.805-11.928-4.805-20.834v-97.2q0-13.362,4.805-22.11c3.083-5.63,9.938-8.48,20.4-8.687h86.846a20.909,20.909,0,0,0,20.908-20.907v-.147a20.909,20.909,0,0,0-20.908-20.907Z",
    transform: "translate(2585.335 35.129)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 114.437,
    height: 42.516,
    rx: 1.723,
    transform: "translate(3955.007 1588.13)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(3031.895 1512.21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M1632.512,1634.16V1475.577a23.074,23.074,0,0,0-46.148,0v104.257Z",
    transform: "translate(-1422.9 -1447.885)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M1726.66,1599.842l-125.408-143.369a17.032,17.032,0,0,0-28.358,12.718v205.421a23.066,23.066,0,0,0,23.067,23.067h0a23.065,23.065,0,0,0,23.067-23.067V1545.795l135.215,152.638a17.028,17.028,0,0,0,28.261-12.8v-20.021Z",
    transform: "translate(-1572.893 -1452.128)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M1729.284,1726.858a110.94,110.94,0,0,1-48.442-10.848,127.454,127.454,0,0,1-39.714-29.454,140.987,140.987,0,0,1-26.865-43.563,149.168,149.168,0,0,1,0-106.825,140.521,140.521,0,0,1,26.865-43.751,127.679,127.679,0,0,1,39.714-29.468,114.345,114.345,0,0,1,97.224,0,127.7,127.7,0,0,1,39.715,29.468,140.523,140.523,0,0,1,26.866,43.751,149.181,149.181,0,0,1,0,106.825,140.989,140.989,0,0,1-26.866,43.563,127.469,127.469,0,0,1-39.715,29.454A111.677,111.677,0,0,1,1729.284,1726.858Zm.17-227.386a66.158,66.158,0,0,0-30.761,7.4,84.4,84.4,0,0,0-24.984,19.712,94.214,94.214,0,0,0-16.94,28.736,97.019,97.019,0,0,0,0,68.508,97.269,97.269,0,0,0,16.94,28.75,83.251,83.251,0,0,0,24.984,19.884,67.614,67.614,0,0,0,61.51,0,83.181,83.181,0,0,0,25-19.884,97.582,97.582,0,0,0,16.939-28.75,97.189,97.189,0,0,0-16.939-97.244,84.324,84.324,0,0,0-25-19.712A66.077,66.077,0,0,0,1729.454,1499.473Z",
    transform: "translate(1712.403 35.512)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M1764.705,1457.3v162.4a20.427,20.427,0,0,0,20.436,20.433h5.267a20.433,20.433,0,0,0,20.433-20.433V1457.3Z",
    transform: "translate(1932.276 105.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M1922.8,1452.482H1779.437a20.434,20.434,0,1,0,0,40.868h2.05v-.035h141.389v.012a20.422,20.422,0,0,0-.072-40.844Z",
    transform: "translate(1868.767 51.888)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M1573.459,1565.827H1566.9c-8.982,48.854-37.728,93.605-82.333,93.605a71.325,71.325,0,0,1-30.81-6.748,83.589,83.589,0,0,1-25.045-17.971,84.91,84.91,0,0,1-16.977-26.039,81.005,81.005,0,0,1,0-62.456,84.5,84.5,0,0,1,16.977-26.2,83.585,83.585,0,0,1,25.045-17.958,71.356,71.356,0,0,1,30.81-6.771c33.661,0,43.877,8.725,56.035,14.074,11.165,4.915,18.592,4.394,26.224-3.7h0c10.229-10.837,7.608-28.963-5.544-35.954-15.569-8.264-37.945-17.582-76.714-17.582a120.023,120.023,0,0,0-48.442,9.889,128.645,128.645,0,0,0-39.812,26.854,127.16,127.16,0,0,0-27.022,39.885,123.189,123.189,0,0,0,0,97.063,127.183,127.183,0,0,0,66.835,66.57,120.007,120.007,0,0,0,48.442,9.89c98.118,0,117.74-85.645,117.74-103.81C1602.3,1581.869,1590.071,1565.827,1573.459,1565.827Z",
    transform: "translate(2785.393 31.048)",
    fill: "#f46e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M1390.176,1503.024h28.94c9.2-13.265,14.065-28.906,16.637-41.525h-45.577a20.762,20.762,0,0,0-20.761,20.763h0A20.762,20.762,0,0,0,1390.176,1503.024Z",
    transform: "translate(2897.751 135.376)",
    fill: "#f46e41"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotegWebsiteLogo2);
export default __webpack_public_path__ + "static/media/noteg_website_logo_2.3ab5ea7708ef241156b4c8e644a3cd79.svg";
export { ForwardRef as ReactComponent };